/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserPastBookingsListResponse } from '../../models/user-past-bookings-list-response';

export interface BookingControllerUserPastBookings$Params {
  user_id: number;
}

export function bookingControllerUserPastBookings(http: HttpClient, rootUrl: string, params: BookingControllerUserPastBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserPastBookingsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerUserPastBookings.PATH, 'get');
  if (params) {
    rb.path('user_id', params.user_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserPastBookingsListResponse;
      }>;
    })
  );
}

bookingControllerUserPastBookings.PATH = '/booking/user/{user_id}/past-travels';
